export default __webpack_public_path__ + "images/a7cb41db836df1693eb7ee9a78fb6216-public_speaker.webp";